import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';

export default function EPICard(props) {
  return (
    <React.Fragment>
      {props.containsEPI &&
        <div className="epi-info">
          <h2>What is EPI?</h2>
          <p>
            EPI: A new tool to measure student’s academic consistency for success in
            targeted competitive exam (introduced from 2019-20 session) It is
            Examination Performance Index based on a student’s
            consistency/growth/decline in academic learning based on a dynamic
            scientific analysis of his/her scores in each test at ALLEN.
      </p>

        The formulae of EPI include overall factors like:
        <ul>
            <li>Toughness level of test</li>
            <li>Range of scores by other students</li>
            <li>Average scores in the test</li>
            <li>Student’s current & previous test scores</li>
            <li>Student’s consistency/growth/decline over tests so far</li>
          </ul>

          <h3>Most Important :</h3>
          <p>
            From your 3rd test onwards it will be shown that at your EPI what rank
            in JEE/NEET was achieved by ALLEN students in previous years. (From the
            first test by default your base EPI will start from 500.00)
      </p>
        </div>
      }
      <div className="epi-info">
        <h3>What is Percentile ?</h3>
        <p>
          Percentile is calculated with respect to the highest marks scored in the
          subject. The highest score obtained by any student in a subject is taken
          as 100 percentile and relative to it percentile of all students is
          calculated. In the similar manner overall score percentile is
          calculated. For example in a subject highest score is 75 and a student
          obtained 56 then his percentile will be calculated as 57*100/75.
      </p>
      </div>
    </React.Fragment>
  );
}
EPICard.propTypes = {
  containsEPI: PropTypes.bool,
};
